import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

interface Props {
	showNavbar?: boolean;
}

export const NavbarWrapper = styled.div<Props>`
	height: 100px;
	background-color: #fff;
	position: ${(props) => (props.showNavbar ? 'fixed' : 'relative')};
	width: 100%;
	${(props) =>
		props.theme.dir === 'ltr' ? 'padding-left: 64px;' : 'padding-right: 64px;'}
	${(props) =>
		props.theme.dir === 'ltr'
			? 'padding-right: 40px;'
			: 'padding-left: 40px;'}  
    z-index: 6;
	box-sizing: border-box;
	.logo {
		cursor: pointer;
		padding: 0;
		border: 0;
		background: inherit;
		display: flex;
	}
	.container {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		height: 100%;
	}
	.actions {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.action-item {
		margin: 0 12px;
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	.links {
		font-size: 1rem;
		line-height: 160%;
		color: ${colors.dark};
		white-space: nowrap;
		transition: 0.3s all;
		display: flex;
		align-items: center;
		.dropdown-icon {
			margin-top: 5px;
		}
		&:hover {
			color: ${colors.primary};
		}
	}
	.mobile-menu {
		display: none;
	}
	.menu-icon {
		display: none;
		.burger-menu {
			width: ${(props) => (props.showNavbar ? '12px' : '24px')};
			height: ${(props) => (props.showNavbar ? '12px' : '24px')};
		}
	}
	.actions-responsive {
		display: none;
	}
	.nav-elements {
		height: 100%;
		.search-input {
			display: none;
		}
	}
	.nav-elements .tabs {
		display: flex;
		justify-content: space-between;
		list-style-type: none;
		cursor: pointer;
		height: 100%;
	}
	.nav-elements .tabs .menu {
		${(props) =>
			props.theme.dir === 'ltr' ? 'margin-right: 30px;' : 'margin-left: 30px;'}
		height: 100%;
		display: flex;
		align-items: center;
		.submit-challenge {
			width: 150px;
		}
	}
	.navbar {
	}
	.dropdown-menu {
		float: left;
		overflow: hidden;
	}

	.dropdown-menu .dropbtn {
		font-size: 16px;
		border: none;
		outline: none;
		color: white;
		padding: 14px 16px;
		background-color: inherit;
		font-family: inherit;
		margin: 0;
	}

	.navbar span:hover,
	.dropdown-menu:hover .dropbtn {
		background-color: red;
	}

	.dropdown-content {
		display: none;
		position: absolute;
		background-color: #f9f9f9;
		min-width: 160px;
		box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
		z-index: 1;
		.archives {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
	}

	.dropdown-content span {
		float: none;
		color: black;
		padding: 12px 16px;
		text-decoration: none;
		display: block;
		text-align: left;
	}

	.dropdown-content span:hover {
		background-color: #ddd;
	}

	.dropdown-menu:hover .dropdown-content {
		display: block;
	}

	.selected {
		transition: all 0.2s ease-in;
		border-bottom: 3px solid ${colors.primary};
		align-items: center;
		justify-content: center;
		&::before {
			content: '';
			position: absolute;
			width: 8.17px;
			height: 8.17px;
			bottom: 0;
			background: #ff7b02;
			border-radius: 2px;
			transform: rotate(45deg);
		}
	}

	@media ${device.tablet} {
		.nav-elements .tabs .menu {
			margin-left: 0;
		}

		.logout-btn-text {
			${(props) =>
				props.theme.dir === 'ltr' ? 'margin-right: 8px;' : 'margin-left: 8px;'}
		}
		.container {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		.mobile-menu {
			display: flex;
			height: 100%;
			.action-item {
				margin: 0 6px;
			}
		}
		.menu-icon {
			display: block;
			cursor: pointer;
			width: 80px;
			height: 100%;
			padding: 5px;
			border: 1px solid transparent;
			background: ${colors.primary};
			justify-content: center;
			align-items: center;
			display: flex;
			box-sizing: border-box;
		}
		.actions {
			display: none;
		}
		.actions-responsive {
			display: flex;
			justify-content: space-around;
			align-items: center;
		}
		.nav-elements {
			position: absolute;
			${(props) => (props.theme.dir === 'ltr' ? 'right: 0px;' : 'left: 0px;')}
			top: 85px;
			background-color: white;
			width: 0;
			height: calc(100vh - 85px);
			transition: all 0.3s ease-in;
			overflow: hidden;
			margin: 0;
			border-top: 1px solid rgba(44, 56, 63, 0.2);
			.search-input {
				display: block;
				margin: 32px 17px;
			}
		}
		.selected {
			border-bottom: 2px solid ${colors.primary} !important;
			justify-content: inherit;
			&::before {
				display: none;
			}
		}
		.nav-elements.active {
			position: fixed;
			width: 100%;
		}
		.nav-elements .tabs {
			display: flex;
			flex-direction: column;
			height: auto;
			padding: 0 20px;
			align-items: center;
		}

		.nav-elements .tabs .menu {
			margin-right: unset;
			margin-top: 19px;
			${(props) =>
				props.theme.dir === 'ltr'
					? 'margin-left: 22px;'
					: 'margin-right: 22px;'}
			border-bottom: 1px solid rgba(44, 56, 63, 0.1);
			.links {
				font-weight: 500;
				font-size: 14px;
			}
		}
		padding-left: 16px;
		padding-right: 0px;
		height: 86px;
	}

	@media ${device.mobile} {
		.nav-elements .tabs .menu {
			margin-left: 0;
		}
		.mobile-menu {
			display: flex;
			height: 100%;
			.action-item {
				margin: 0 6px;
			}
		}
		.container {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		.menu-icon {
			display: block;
			cursor: pointer;
			width: 80px;
			height: 100%;
			padding: 5px;
			border: 1px solid transparent;
			background: ${colors.primary};
			justify-content: center;
			align-items: center;
			display: flex;
			box-sizing: border-box;
		}
		.actions {
			display: none;
		}
		.actions-responsive {
			display: flex;
			justify-content: space-around;
			align-items: center;
			margin-top: 32px;
		}
		.nav-elements {
			position: absolute;
			right: 0px;
			top: 85px;
			background-color: white;
			width: 0;
			height: calc(100vh - 85px);
			transition: all 0.3s ease-in;
			overflow: hidden;
			margin: 0;
			border-top: 1px solid rgba(44, 56, 63, 0.2);
			.search-input {
				display: block;
				margin: 32px 17px;
			}
		}
		.selected {
			border-bottom: 2px solid ${colors.primary} !important;
			justify-content: inherit;
			&::before {
				display: none;
			}
		}
		.nav-elements.active {
			position: fixed;
			width: 100%;
		}
		.nav-elements .tabs {
			display: flex;
			flex-direction: column;
			height: auto;
			padding: 0 20px;
		}
		.nav-elements .tabs .menu {
			margin-top: 19px;
			border-bottom: 1px solid rgba(44, 56, 63, 0.1);
			.links {
				font-weight: 500;
				font-size: 14px;
			}
			.submit-challenge {
				width: 100%;
			}
		}
		padding-left: 16px;
		padding-right: 0px;
		height: 86px;
	}
`;
